<template>
  <div class="node-left-warp">
    <el-form ref="nodeForm" :model="form" class="nodeForm" label-width="70px"
             :rules="rules" :hide-required-asterisk="true">
      <div class="node-item">
        <div class="tips" :class="className=='right'?'rightLeftLine':''">实际值小于标准值</div>
        <el-form-item label="触发指令" prop="trigger">
          <el-select v-model="form.trigger" @change="directiveChange">
            <el-option :label="item.dictValue" :value="item.dictCode" v-for="item in optionOperate"
                       :key="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下一指标" prop="indexCode" v-if="form.trigger=='next'">
          <el-select v-model="form.indexCode" @change="nodeChangeHandle">
            <el-option :label="option.name" :value="option.code" v-for="option in pressOption"
                       :key="option.code" :disabled="option.disabled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标准值" prop="standardValue" v-if="form.trigger=='next'">
          <el-input v-model="form.standardValue" placeholder="请输入" v-if="form.indexCode!='cost'">
            <template slot="append" v-if="indexCodeType">%</template>
          </el-input>
          <el-button plain v-else @click="openCostDialog">查看</el-button>
        </el-form-item>
        <el-form-item label="偏差比例" prop="deviationRate" v-if="form.trigger=='next'">
          <el-input v-model="form.deviationRate" placeholder="请输入">
            <template slot="append">%</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="leftWarp">
        <node-left ref="nodeLeftDom" :list="form.leftNode" :optionSelect="pressOption"
                   :optionOperate="optionOperate"
                   v-if="form.indexCode" v-bind="$attrs"></node-left>
        <node-right ref="nodeRightDom" :list="form.rightNode" :optionSelect="pressOption"
                    :optionOperate="optionOperate"
                    v-if="form.indexCode" v-bind="$attrs"></node-right>
      </div>
      <cost-dialog ref="costDialogDom" @costDialogHandle="costDialogHandle" v-bind="$attrs" v-if="form.indexCode=='cost'"></cost-dialog>
    </el-form>
  </div>
</template>

<script>
    import nodeLeftJs from './nodeLeft.js'

    export default nodeLeftJs
</script>

<style lang="scss" scoped>
  @import "nodeLeft";
</style>



// WEBPACK FOOTER //
// src/pages/recommend/automaticPutin/intellPromotion/component/nodeItem/nodeLeft/nodeLeft.vue